import React, { createContext, useContext, ReactNode } from 'react';
import { useAppInfo } from '../hooks/useAppInfo';

interface AppInfo {
  name: string;
  version: string;
}

interface AppInfoContextType {
  appInfo: AppInfo;
  loading: boolean;
}

const AppInfoContext = createContext<AppInfoContextType | undefined>(undefined);

export const AppInfoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { appInfo, loading } = useAppInfo();

  return (
    <AppInfoContext.Provider value={{ appInfo, loading }}>
      {children}
    </AppInfoContext.Provider>
  );
};

export const useAppInfoContext = () => {
  const context = useContext(AppInfoContext);
  if (context === undefined) {
    throw new Error('useAppInfoContext must be used within an AppInfoProvider');
  }
  return context;
};